<template>
    <rkm-area
        no-margin-top
        title="Observações da pós-consulta"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :maxlength="validations.observacoes.max"
                    :validations="validations.observacoes"
                    name="Observações da pós-consulta"
                    rows="4"
                    v-model="data.model.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                observacoes: {max: 5000},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>